import styled from 'styled-components';
export const PropertyBoxContainer = styled.div `
  display: flex;
  flex-direction: column;
  padding: 12px 10px;
  gap: ${({ theme }) => theme.spacing.md}px;
  background-color: ${({ theme }) => theme.colors.white_1};
  border: 1px solid ${({ theme }) => theme.colors.grey_4};
  border-radius: 4px;
  box-shadow: 2px 4px 15px 1px ${({ theme }) => theme.colors.grey_1_pale};
`;
export const PropertyBoxContent = styled.div `
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;
export const PropertyBoxLabelGroup = styled.div `
  width: 100%;
  border-width: 1px;
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  gap: 12px;
  align-items: center;
  width: fit-content;
  height: fit-content;
  line-height: 1;
`;
export const PropertyBoxInvalidMessage = styled.div `
  width: 100%;
  border-width: 1px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.md}px;
  align-items: center;
`;
export const CandidateStatusCtas = styled.div `
  width: 100%;
  border-width: 1px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  padding: ${({ theme }) => `${theme.spacing.md}px ${theme.spacing.lg}px`};
  gap: ${({ theme }) => theme.spacing.md}px;
`;
export const CandidateStatusContent = styled.div `
  width: 100%;
  border-width: 1px;
  box-sizing: border-box;
  cursor: pointer;
  text-decoration: underline;
  text-align: center;
`;
